import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Cart = {
  cart_id?: number; // 장바구니 idx
  user_id?: number; // 유저 idx
  product_id?: number; // 상품 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  cart_num?: number; // 수량
  is_fixed?: string; // 고정여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Cart
   * --
   */
  getCarts: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_CART, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Cart
   * --
   */
  getCart: async (idx: number, params?: { [key: string]: string | number }) => {
    try {
      const url = parameterToPath(APIConstant.GET_CART, { cart_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Cart
   * --
   */
  createCart: async (body: Cart) => {
    try {
      const res = await $http.post(APIConstant.CREATE_CART, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Cart
   * --
   */
  updateCart: async (body: Cart) => {
    try {
      const { cart_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_CART, {
        cart_id: cart_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Cart
   * --
   */
  deleteCart: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_CART, {
        cart_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Cart
   * --
   */
  upsertBulkCart: async (body: Cart[]) => {
    try {
      const res = await $http.post(APIConstant.UPSERT_BULK_CART, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Cart
   * --
   */
  bulkDeleteCart: async (body: Cart[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_DELETE_CART,
        body,
        'DELETE'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
